import Api from '@/services/Index';

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/toles/applications' ,config);
}
const register = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/start-application', data);
}
const verify = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/verify-application', data);
}
const login = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/login-application', data);
}
const calculateAmount = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/amount-calculator', data);
}
const updateApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/update-application', data);
}
const addApplication = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/add-application', data);
}
const payment = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/toles/application/make-payment', data);
}
const excelExport = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/toles/applications/excel-export',{...config,responseType:"arraybuffer"});
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/toles/applications/'+id);
}

export default {
    getAll,
    register,
    verify,
    login,
    calculateAmount,
    updateApplication,
    payment,
    excelExport,
    del,
    addApplication
}
